import React from "react";
import styled from "styled-components";

import { MEDIA_DESKTOP } from "../../../helpers/theme";
import { Button } from "../Button";
import printJS from "print-js";

export type PrintButtonProps = {
  label: string;
  elementId?: string;
  src?: string;
};

export const PrintButton = ({
  elementId,
  label,
  src,
}: PrintButtonProps): JSX.Element => {
  const onPrint = () => {
    try {
      if (src) {
        printJS({
          printable: src,
          type: "image",
          maxWidth: 1000,
          imageStyle: "width:100%; height: 100%; object-fit: contain;",
        });
        return;
      }
      if (elementId) {
        printJS({
          printable: elementId,
          type: "html",
          maxWidth: 1000,
        });
      }
    } catch (e) {
      console.log(e);
    }
  };

  return <StyledButton onClick={onPrint} label={label} />;
};

const StyledButton = styled(Button)`
  width: 100%;
  ${MEDIA_DESKTOP} {
    width: fit-content;
  }
`;

export default PrintButton;
